import { ICopiaBlocosUseCase } from "../../../presentation/useCases/create/copia_blocos_use_case";
import { IIncorporacaoRepository } from "../../repositories/incorporacao_repositories";

/**
 * CopiaBlocosUseCase
 */

export class CopiaBlocosUseCase implements ICopiaBlocosUseCase {
  constructor(private readonly repository: IIncorporacaoRepository) { }
  async copiaBlocos(idBloco: number, numeroCopias: number): Promise<void> {
    await this.repository.copiaBlocos(idBloco, numeroCopias);

  }
}
